
const ProductShowcase = () => {
  const productSeries = [
    {
      name: '若享系列',
      subtitle: '体验入门',
      description: '为初次接触普洱茶的茶友精心调配，口感温和，香气清雅，是了解普洱茶文化的最佳选择。',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/c112105dfc4a683a6199fdb3b1af45a4.png',
      features: ['温和口感', '香气清雅', '入门首选', '精美包装'],
      bgColor: 'bg-[#3E3A39]',
      textColor: 'text-white'
    },
    {
      name: '正本清源系列',
      subtitle: '日常品饮',
      description: '传承古法工艺，选用优质原料，适合日常品饮的经典普洱茶，让每一天都有好茶相伴。',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/58aa4b08c3172fa17184523114a0a6c3.jfif',
      features: ['古法工艺', '优质原料', '日常品饮', '经典传承'],
      bgColor: 'bg-[#603B28]',
      textColor: 'text-white'
    },
    {
      name: '大师造-茗山荟系列',
      subtitle: '礼品鉴赏',
      description: '由制茶大师亲自监制，选用名山古茶，工艺精湛，包装精美，是商务送礼的不二之选。',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/86e3b6b920246dcb1ad0afde08903259.png',
      features: ['大师监制', '名山古茶', '精美包装', '送礼佳品'],
      bgColor: 'bg-[#E7BC71]',
      textColor: 'text-[#3E3A39]'
    },
    {
      name: '瑞贡珍藏系列',
      subtitle: '收藏投资',
      description: '臻选百年古树茶，传统工艺精制，具有极高的收藏价值和升值潜力，值得珍藏传世。',
      image: 'https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/33b77272d91ddf06e0c0fb8ba7265386.jfif',
      features: ['百年古树', '传统工艺', '收藏价值', '传世珍品'],
      bgColor: 'bg-slate-700',
      textColor: 'text-white'
    }
  ];

  return (
    <section id="products" className="py-12 lg:py-16 bg-white">
      <div className="px-6 lg:px-16">
        <div className="text-center mb-8 lg:mb-12">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary font-serif mb-3">
            产品系列
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            四大产品系列，满足不同需求，从初入门径到珍藏传世，每一款都承载着马帮精神
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 max-w-6xl mx-auto">
          {productSeries.map((series, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 hover:scale-105"
              data-product-shop
            >
              <div className={`${series.bgColor} p-6 lg:p-8`}>
                <div className="flex flex-col lg:flex-row items-center space-y-4 lg:space-y-0 lg:space-x-6">
                  <div className="flex-1">
                    <div className="mb-3">
                      <h3 className={`text-xl lg:text-2xl font-bold font-serif mb-1 ${series.textColor}`}>
                        {series.name}
                      </h3>
                      <p className={`text-base font-medium ${series.textColor === 'text-white' ? 'text-gray-200' : 'text-[#603B28]'}`}>
                        {series.subtitle}
                      </p>
                    </div>
                    
                    <p className={`leading-relaxed mb-4 text-sm ${series.textColor === 'text-white' ? 'text-gray-100' : 'text-gray-700'}`}>
                      {series.description}
                    </p>

                    <div className="grid grid-cols-2 gap-2 mb-4">
                      {series.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center space-x-1">
                          <i className={`ri-check-line text-sm ${series.textColor === 'text-white' ? 'text-[#E7BC71]' : 'text-[#603B28]'}`}></i>
                          <span className={`text-xs ${series.textColor === 'text-white' ? 'text-gray-200' : 'text-gray-700'}`}>{feature}</span>
                        </div>
                      ))}
                    </div>

                    <button className={`${series.textColor === 'text-white' ? 'bg-[#E7BC71] hover:bg-[#E7BC71]/90 text-[#3E3A39]' : 'bg-[#603B28] hover:bg-[#603B28]/90 text-white'} px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap`}>
                      了解详情
                    </button>
                  </div>

                  <div className="w-full lg:w-64 flex-shrink-0">
                    <img
                      src={series.image}
                      alt={series.name}
                      className="w-full h-64 lg:h-80 object-cover object-top rounded-lg shadow-lg group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12 lg:mt-16">
          <div className="bg-gray-50 rounded-xl p-6 lg:p-8 max-w-4xl mx-auto">
            <h3 className="text-xl lg:text-2xl font-bold text-primary font-serif mb-3">
              品味传承，选择马帮瑞贡
            </h3>
            <p className="text-base text-gray-600 mb-6 max-w-2xl mx-auto">
              无论您是初次品茗的新手，还是资深的茶道爱好者，我们都有适合您的产品系列
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button className="bg-secondary hover:bg-secondary/90 text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">
                在线选购
              </button>
              <button className="border-2 border-secondary text-secondary hover:bg-secondary hover:text-white px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap">
                预约品鉴
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductShowcase;
